<template><div><h1>为什么不能直接引用 cdn 链接</h1>
<p>原因见 <router-link to="/zh-CN/faq/why-use-vue-file-for-distribution.html">为什么使用 .vue 源码分发而不是 js 文件</router-link>。因为并不会在源码里提供 umd 脚本也不会在发布时发布 umd 脚本，因此没有 cdn 链接。</p>
</div></template><script>
export default {
  head: {"title":"为什么不能直接引用 cdn 链接 | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// why-cannot-i-use-vux-with-cdn-61.vue?5fc6d432